import home from './index.vue'
import homeCorporate from './corporate.vue'

export default [
  {
    path: '/',
    redirect: '/landing',
  },
  {
    path: '/landing/:bookingNumber/:surname',
    name: 'landingauth',
    component: home,
  },
  {
    path: '/landing/:bookingNumber/:surname/:source',
    name: 'landingauthsource',
    component: home,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
  },
  {
    path: '/communications/:bookingNumber/:surname/:source',
    name: 'commsauthsource',
    component: home,
    props: (route) => ({
      bookingNumber: route.params.bookingNumber,
      surname: route.params.surname,
      source: route.params.source,
    }),
  },
  {
    path: '/landing',
    name: 'landing',
    component: home,
    meta: {
      requiresAuth: true,
      breadCrumb: [
        // needs to be added to corp below - but also repeated in navigation router, Home needs to be re organised
        { text: 'ViewTrail Home' },
      ],
    },
  },
  {
    path: '/landing-corp',
    name: 'landingCorporate',
    component: homeCorporate,
    meta: {
      requiresAuth: true,
    },
  },
]
